import styled from '@emotion/styled';
import { T } from '@tolgee/react';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { useMemo } from 'react';
import { getAppProductName } from 'hooks/useTrans';

export const DescriptionPopup = () => {
  const sysLang = useSystemLanguageValue();

  const docLink = useMemo(() => {
    if (sysLang === 'zh-CN') {
      return 'https://leyan.yuque.com/czpqnb/nmiwyb/ty5lp9vmcq7egcrt';
    }
    return 'https://chatplus.ganjutech.com/wiki/en/#intelligent-assignment';
  }, [sysLang]);

  return (
    <Wrapper>
      <T
        keyName="customer_allocated_rules_desc_copy"
        params={{
          appProductName: getAppProductName(),
          // eslint-disable-next-line react/jsx-no-target-blank,jsx-a11y/anchor-has-content
          doc: <a href={docLink} target="_blank" rel="" />,
          list: <ul className="pl-8" />,
          listItem: <li />,
          p: <p />,
          strong: <strong />,
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 540px;
  font-size: 14px;

  p {
    margin: 0;
    margin-bottom: 4px;
  }

  strong {
    color: #336fff;
  }
`;
